module.exports = __webpack_public_path__ + "resources/img/bg-customer-fcnote@2x.ca87d836.jpg";